import { Controller } from "@hotwired/stimulus"

// Toggles a hidden content region (e.g. the dropped-commits "Show range" note).
// Optionally rotates a `chevron` target 90° when open (no-op if absent).
export default class extends Controller {
  static targets = ["content", "chevron"]

  toggle() {
    this.contentTarget.classList.toggle("hidden")
    if (this.hasChevronTarget) {
      const open = !this.contentTarget.classList.contains("hidden")
      this.chevronTarget.style.transform = open ? "rotate(90deg)" : ""
    }
  }
}
